import React, { FC, InputHTMLAttributes, ReactNode } from "react";
import styled from "styled-components";

interface SliderProps extends InputHTMLAttributes<HTMLInputElement> {
  min: number;
  max: number;
  value: number;
  step?: number;
  setValue: (value: number) => void;
}

const StyledRange = styled.input`
  background-color: transparent;
  width: 100% !important;
`;

const Slider: FC<SliderProps> = ({
  min,
  max,
  value,
  step = 0.01,
  setValue,
  ...props
}) => {
  return (
    <StyledRange
      type="range"
      min={min}
      max={max}
      value={value}
      step={step}
      onChange={e => setValue(Number(e.target.value))}
      {...props}
      style={
        {
          "--val": `${((value - min) / (max - min)) * 100}%`,
        } as React.CSSProperties
      }
    />
  );
};

export default Slider;
